import React, { useRef, useLayoutEffect } from "react"
import { graphql } from "gatsby"
import { DarlingAnimation, GroupAnimation, JiggleArrow } from "../../icons"
import useVenuesQuery from "../../../hooks/use-venues-query"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import gsap from "gsap"

const IntroAnimation = ({show}) => {
  const venues = useVenuesQuery()
  const topRef = useRef()
  const bottomRef = useRef()
  const middleRef = useRef()
  const arrowRef = useRef()
  const introRef = useRef()

  useLayoutEffect(() => {
    const handleScroll = () => {
      document.documentElement.classList.add('animation-loaded');
    }

    const timeout = setTimeout(() => {
      document.documentElement.classList.add('animation-loaded');
    }, 5000);

    window.addEventListener("scroll", handleScroll)
    return () => {
      clearTimeout(timeout); // Clears the timeout when the component unmounts
      window.removeEventListener("scroll", handleScroll)

    }
  }, [])

  if (!show) return null

  return (
    <>
      <div className="intro-animation" ref={introRef}>
        <div className="intro-animation__inner">
          <div className="intro-animation__top" ref={topRef}>
            <DarlingAnimation />
          </div>

          <div className="intro-animation__middle" ref={middleRef}>
            <ul>
              {venues.map((venue, index) => {
                return (
                  <li key={index}>
                    <Link to={venue.permalink}>{venue.title}</Link>
                  </li>
                )
              })}
            </ul>
          </div>

          <div className="intro-animation__bottom" ref={bottomRef}>
            <GroupAnimation />
          </div>

          <button ref={arrowRef}><JiggleArrow /></button>
        </div>
      </div>
    </>
  )
}

export const query = graphql`
  fragment IntroAnimationProps on DatoCmsIntroAnimation {
    ... on DatoCmsIntroAnimation {
      id
      show
    }
  }
`;

export default IntroAnimation